import { Injectable } from '@angular/core';
import { ContractLocalParameters } from '../4.2.contract/contract.parameters/contract.local.parameters';

@Injectable({
    providedIn: 'root'
})
export class LocalParemeters implements ContractLocalParameters{

    //private cryptoKey: string = 'ci8/LgwPZz8/P05mAT8/Pz8/MVVDPwl5';
    private cryptoKey: string = 'O1M/Py8/PzI/Plo/BT8/P24/P3djPz8/';

    getCryptoKey(): string{
        return this.cryptoKey;
    }
    
}